import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getTranslation } from "orion-components/i18n";
import { CBMenu } from "orion-components/CBComponents";
import PropTypes from "prop-types";
import { cameraClustersService } from "client-app-core";
import { SelectMultipleDialog } from "orion-components/SharedComponents";

const WidgetMenu = ({ addCameraClustersToEntity, cameraClusters }) => {
	const [dialog, setDialog] = useState("");
	const [dialogItems, setDialogItems] = useState([]);
	const [dialogSelectedItemsId, setDialogSelectedItemsId] = useState([]);

	useEffect(() => {
		cameraClustersService.getClustersByFilter({}, (err, response) => {
			if (err) {
				console.log(err);
			} else {
				setDialogItems(response);
			}
		});
	}, []);

	useEffect(() => {
		setDialogSelectedItemsId(cameraClusters);
	}, [cameraClusters]);

	const getSelectedOptions = (items) => {
		let selectedIds = [...dialogSelectedItemsId];

		items.forEach((data) => {
			// Check if the ID is already in the selected array
			if (selectedIds.includes(data.id)) {
				// Remove the ID by filtering it out
				selectedIds = selectedIds.filter((id) => id !== data.id);
			} else {
				// Add the new ID to the selected array
				selectedIds.push(data.id);
			}
		});
		setDialogSelectedItemsId(selectedIds);
		addCameraClustersToEntity(selectedIds);
	};

	const _closeDialog = () => {
		setDialog("");
	};


	const menuItems = [
		{
			label: "global.profiles.widgets.cameraClusters.addCameraClusters",
			onClick: () => {
				setDialog("cluster-selection-dialog");
			},
			disabled: false,
			showMenuItem: true
		}
	];

	return (
		<>
			<CBMenu menuItems={menuItems} />
			{dialog === "cluster-selection-dialog" && (
				<SelectMultipleDialog
					open={dialog === "cluster-selection-dialog"}
					closeDialog={_closeDialog}
					dialogItems={dialogItems}
					dialogTitle={getTranslation("global.profiles.widgets.cameraClusters.chooseCameraClusters")}
					getSelectedOptions={getSelectedOptions}
					dialogItemIcon="cameraClusters"
					dialogItemTextPropPath={"name"}
					dialogSelectedItemsId={dialogSelectedItemsId}
				/>
			)}
		</>
	);
};

WidgetMenu.propTypes = {
	cameraClusters: PropTypes.array.isRequired,
	addCameraClustersToEntity: PropTypes.func
};

WidgetMenu.defaultProps = {
	addCameraClustersToEntity: () => { }
};

export default WidgetMenu;
